


















import Vue from 'vue'
import SubscribeTeamAssets from '@/mixins/SubscribeTeamAssets'
import { Transfer } from 'element-ui'
import { AssetGroup, AssetGroupType } from '@/types/assets'
import './ManageCastFolders.scss'
import '@/styles/components/transfer.scss'
import { KeyDict } from '@/types'
import { pickBy } from 'lodash'

interface AssetGroupTable {
  key: string
  label: string
  type: AssetGroupType
  icon: string
}

export default Vue.extend({
  name: 'ManageCastFolders',
  props: {
    // until Vuex store always has correct state we still allow setting legacy castFolders prop
    castfolders: {
      type: Object
    }
  },
  mixins: [ SubscribeTeamAssets ],
  computed: {
    rootFolders (): KeyDict<AssetGroup> {
      return pickBy(this.allfolders, folder => !folder.parent_id)
    },
    allfolders (): KeyDict<AssetGroup> {
      return this.$store.direct.state.assets.folderList
    },
    // AssetManager vs CreateEditCast component
    selectKeys (): KeyDict<boolean> {
      if (!!this.castfolders) {
        // passed via vue.prop
        return this.castfolders
      }

      // passed via vuex store
      return this.toKeyPairs(this.$store.direct.getters.events.castAssetGroups)
    },
    formattedFolders (): AssetGroupTable[] {
      const newArray: AssetGroupTable[] = []
      Object.values(this.rootFolders).forEach(folder => {
        let label = folder.name
        let icon = ''
        const type = folder.type || AssetGroupType.Folder
        switch (folder.type) {
          case 'hashtag':
            icon = 'brands/twitter'
            label = '#' + label
            break
          case 'handle':
            icon = 'brands/twitter'
            label = '@' + label
            break
          case 'ig_hashtag':
            icon = 'brands/instagram'
            label = '#' + label
            break
          case 'ig_handle':
            icon = 'brands/instagram'
            label = '@' + label
            break
        }
        newArray.push({ key: folder.id, label, type, icon })
      })
      return newArray.sort((foldera, folderb) => foldera.label.localeCompare(folderb.label))
    }
  },
  data: () => ({
    selectedFolders: [] as any[]
  }),
  created () {
    this.formatFolders()
  },
  methods: {
    isInstagram (type: AssetGroupType): boolean {
      return !!type && [AssetGroupType.InstagramHashtag, AssetGroupType.InstagramHandle].includes(type)
    },
    isTwitter (type: AssetGroupType): boolean {
      if (!type) {
        return false
      }
      return type && [AssetGroupType.TwitterHashtag, AssetGroupType.TwitterHandle].includes(type)
    },
    listChanged (): void {
      this.$emit('foldersChanged', this.selectedFolders)
    },
    formatFolders (): void {
      // contains keys { "ABCDE": true, ... }
      this.selectedFolders = []
      for (const folderKey of Object.keys(this.selectKeys)) {
        this.selectedFolders.push(folderKey)
      }
      this.listChanged()
    },
    toKeyPairs (transformArr: KeyDict<AssetGroup>): KeyDict<boolean> {
      const newObject: KeyDict<boolean> = {}
      Object.keys(transformArr).forEach(id => {
        newObject[id] = true
      })
      return newObject
    }
  },
  components: {
    'el-transfer': Transfer
  }
})
